import React, { Component, Fragment } from 'react';
import Raven from 'raven-js';
import classNames from 'classnames';

import { fedopsLogger } from '../../client/fedops';
import compose from '../../lib/utils/compose';

import MainPageSettingsListener from './components/SettingsListener';
import MainPageHeader from './components/Header';
import MainPageEpisodes from './components/Episodes';
import MainPageError from './components/Error';

import { withSettings } from '../../components/context/settings';

import { TPADeviceType } from '@wix/podcasts-common/dist/tpa';
import { withTPA } from '../../components/context/tpa';

import getInitialProps from './MainPage.getInitialProps';

import getStyles from './MainPage.styles';
import styles from './MainPage.scss';

import { IMainPageProps, IMainPageState } from './types';

class MainPage extends Component<IMainPageProps, IMainPageState> {
  static getInitialProps = getInitialProps;

  componentDidMount() {
    if (process.env.NODE_ENV !== 'development') {
      fedopsLogger.appLoaded();
    }

    if (this.props.error) {
      Raven.captureException(this.props.error);
    }
  }

  render() {
    const { params, settings, podcast, episodes, episodesCount, error, tpa } =
      this.props;

    const { deviceType } = tpa.params;
    const dynamicStyles = getStyles({
      colors: settings.colors.main,
      settings: settings.main,
    });

    return (
      <div>
        <MainPageSettingsListener episodes={episodes} />
        <div
          className={classNames(
            styles.pageContainer,
            dynamicStyles.pageContainer,
            {
              mobile: deviceType === TPADeviceType.MOBILE,
              desktop: deviceType === TPADeviceType.DESKTOP,
            },
          )}
        >
          {error || !podcast ? (
            <MainPageError error={error} />
          ) : (
            <Fragment>
              <MainPageHeader podcast={podcast} />
              <MainPageEpisodes
                params={params}
                podcastImage={podcast.image}
                episodes={episodes}
                episodesCount={episodesCount}
              />
            </Fragment>
          )}
        </div>
      </div>
    );
  }
}

export default compose(withTPA, withSettings)(MainPage);
